/**
 * @ GpsTagTracker.vue
 * @Description uwb标签 轨迹
 * @Author
 * @Date
 */
<template>
	<div class="table-item-box padding-l-none" style="padding: 0px;">
		<section style="height: 100%;">
			<el-col style="padding-left: 10px;padding-top: 10px;text-align: left;float: none;position: absolute;z-index: 9; width: auto;">
				<el-form class="condition-form-item" :inline="true" :model="filters" ref="filters" :rules="rules">
					<el-form-item v-if="false" label="选择项目：" prop="projectId">
						<!-- style="position: fixed;top: 114px;right: 430px;" -->
						<el-select v-model="filters.projectId" placeholder="请选择项目" style="width:180px;">
							<el-option v-for="(value,key) in projectInfos" :key="key" :label="value.projectName" :value="key"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="time">
						<!-- style="position: fixed;top: 114px;right: 240px;" -->
						<el-date-picker :picker-options="filters.pickerOptions" v-model="filters.time" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 180px">
						</el-date-picker>
					</el-form-item>
					<el-form-item prop="did">
						<!-- style="position: fixed;top: 114px;right: 10px;" -->
						<el-autocomplete :style="{width:'220px'}" ref="elautocomplete" class="inline-input" v-model="filters.did" :fetch-suggestions="querySearch" placeholder="请输入设备编号" :trigger-on-focus="false" @select="handleSelect" @keyup="changeStyle('block', '.el-autocomplete-suggestion')">
							<i slot="suffix" class="el-input__icon el-icon-search" @click="searchTracker"></i>
						</el-autocomplete>
					</el-form-item>
				</el-form>
			</el-col>
			<div style="height: 100%">
				<!-- height: calc(100vh - 104px) -->
				<OutdoorTracker ref="outdoorTracker" @searchTracker="searchTracker" />
			</div>
		</section>

	</div>
</template>

<script>
	// 组织结构组件
	import ApiOrg from '@/request/api-org';
	// 标签组件
	import ApiGpsTag from '@/request/api-gps-tag';
	// 组件
	import GlobalVar from '@/global/global-variable';

	// 公共函数
	import GlobalFun from "@/global/global-function";
	import Secret from "@/secret/index";

	// GPS 地图 高德
	import OutdoorTracker from './OutdoorTracker';

	export default {
		name: "GpsTagTracker",
		/**
		 * @Des 组件引用
		 * @Auth jsh
		 * @Date 09:41 2021/6/28
		 */
		components: {
			// GPS 地图 高德
			OutdoorTracker,
		},
		/**
		 * @Des 数据定义
		 * @Auth jsh
		 * @Date 09:41 2021/6/28
		 */
		data() {
			return {
				filters: {
					projectId: '',
					did: '',
					time: (new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()),
					beginTime: 0,
					endTime: 0,
					// 隐藏的时间
					pickerOptions: {
						disabledDate(v) {
							return v.getTime() > new Date().getTime()
						}
					},
				},
				projectInfos: {},
				tagInfos: [],
				// 记录 位置点
				posiList: [],
				// 查询对象
				trackObj: {},
				rules: {
					time: [{
						required: true,
						message: '请选择日期',
						trigger: 'false'
					}, ],
					did: [{
						required: true,
						message: '请输入设备编号',
						trigger: 'blur'
					}],
				},
				// route params
				routeParams: {},
			}
		},
		/**
		 * @Des 数据计算
		 * @Auth
		 * @Date
		 */
		computed: {

		}, // computed
		created() {
			// this.searchProject();
		},
		mounted() {
			this.routeParams = Object.assign({}, this.$route.params);

			// 初始化 参数
			this.flushFilters(Object.assign({}, this.routeParams));
		},
		/**
		 * @Des 方法定义
		 * @Auth jsh
		 * @Date 09:42 2021/6/28
		 */
		methods: {
			/**
			 * @Des 初始化 参数
			 * @Auth 
			 * @Date 
			 */
			flushFilters(opt = {}) {
				if(opt.did) {
					this.filters.did = opt.did;
				}
				if(opt.uploadTime) {
					const oDate = new Date(opt.uploadTime);
					const year = oDate.getFullYear();
					this.filters.time = [oDate.getFullYear(), (oDate.getMonth() + 1), oDate.getDate()].join('-');
				}
				
				// 查询对象
				this.trackObj = Object.assign({}, {did: opt.did});
			}, // flushFilters
			
			searchProject() {
				return false;
				this.projectInfos = Object.assign({}, {});
				this.filters.projectId = "";
				this.$request.postJsonRequest(ApiOrg.findLoginProjectApi, {}).then(result => {
					if(result.code == 0) {
						result.data.forEach((row, index) => {
							this.projectInfos[row.projectId] = row;
							this.filters.projectId = row.projectId;
						});
					}
				}).catch(error => {
					console.log("查询登录项目异常：" + this.$request.error.msg);
				})
			},

			/**
			 * @Des 选择建议
			 * @Auth
			 * @Date 2021/8/17
			 */
			handleSelect(item) {
				if (this.$checkEmpty(item.id)) {
					this.filters.did = '';
					return false;
				}
				this.trackObj = item;
				// 查询轨迹
				this.searchTracker();
			},

			/**
			 * @Des 改变样式
			 * @Auth
			 * @Date 2021/8/17
			 */
			changeStyle(status, className) {
				if(this.filters.did.trim() == '') {
					status = "none";
				}
				let dom = document.querySelectorAll(className);
				dom[0].style.display = status;
			},

			/**
			 * 查询标签id
			 * */
			querySearch(queryString, callback) {
				this.filters.did = this.filters.did.toUpperCase().trim();
				if(queryString == '' || this.filters.did.trim() == '') {
					this.changeStyle('none', '.el-autocomplete-suggestion');
					return;
				}
				this.$request.postJsonRequest(ApiGpsTag.searchGpsTagIdApi, {
					// projectId: this.filters.projectId,
					did: this.filters.did,
					limit: 20,
				}).then(result => {
					this.tagInfos = Object.assign([], []);
					if(result.code == 0) {
						result.data.forEach((row, index) => {
							this.tagInfos.push({
								id: row.did,
								value: row.did
							})
						})
					}
					if(this.tagInfos.length > 0) {
						typeof callback == 'function' && callback(this.tagInfos);
					} else {
						typeof callback == 'function' && callback([{id: '',value: '暂无数据'}]);
					}
				}).catch(error => {
					console.log("查询标签ID异常：" + error);
				})
			}, // searchTag

			searchTracker() {
				this.filters.did = this.filters.did.toUpperCase().trim();
				// 空值 中止
				if(this.$checkEmpty(this.filters.did)) return false;
				
				this.$refs.filters.validate(valid => {
					if(!valid) {
						this.posiList = Object.assign([], []);
						this.$refs.outdoorTracker.drawLine(this.filters.did, this.filters.time, this.posiList);
						return false;
					}
					// loading
					this.loading = this.$loading({
						lock: true,
						text: '正在查询轨迹数据...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					// console.log(this.filters.did, this.filters.beginTime, this.filters.endTime)
					this.filters.beginTime = Date.parse(this.filters.time + " 00:00:00");
					this.filters.endTime = Date.parse(this.filters.time + " 23:59:59");

					/*ApiGpsTag.searchGpsTagTrackerApi*/
					this.$request.postJsonRequest(ApiGpsTag.searchDeviceTrackerApi, {
						did: this.filters.did,
						beginTime: this.filters.beginTime,
						endTime: this.filters.endTime,
					}).then(result => {
						this.loading.close();
						this.posiList = Object.assign([], []);
						if(result.code == 0) {
							result.data.forEach((row, index) => {
								if(row.lat_gc != undefined && row.lat_gc != null) {
									row.index = index;
									this.posiList.push(row);
								}
							})
						}
						if(this.posiList.length == 0) {
							this.$message({
								message: '没有查询到轨迹，请修改查询条件',
								type: 'warning',
								showClose: true,
								dangerouslyUseHTMLString: true
							});
						}
						// 缓存  记录 轨迹信息
						this.$refs.outdoorTracker.map_track.clear();
						// 绘制轨迹
						this.$refs.outdoorTracker.receiveTrackData({user: this.trackObj, positionList: this.posiList});
					}).catch(error => {
						console.log("查询标签轨迹异常：" + error);
						this.loading.close();
					})
				});

			}, //searchTracker

		}, // methods

	}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components_outdoor/Outdoor/GpsTagTracker.vue